import React, { Component } from "react";
import { connect } from "react-redux";
import FontAwesome from "react-fontawesome";
import numeral from "numeral";

import BoxButton from "../../Layout/components/BoxButton";
import BoxSection from "../../Layout/components/BoxSection";
import Table from '@mawesi-sas/mws_react_component_table';
import { Input, inputActions } from '@mawesi-sas/mws_react_component_input';
import { tableActions } from '@mawesi-sas/mws_react_component_table';
import {
  obtenerParametro,
  reiniciarEstado,
  showHideModalAdicionarDetalles,
  showHideModalAdicionarCencos,
  eliminarDetalle,
  eliminarRecurso,
} from "../actions";
import { llamarMensajesAlerta } from "../../NuevaSolicitud/actions";
import { showModalConfirmAction } from "../../Layout/actions";

class General extends Component {
  state = {
    holiDays: undefined,
    diasAnti: undefined,
    diasHabilA: undefined,
  };
  componentWillMount() {}

  validarFechaAntiguedad(dateFormated) {
    const daysToSubstract = parseInt(this.state.diasAnti, 10);
    const inputFromFunction = dateFormated;
    const minimumDate = this.validarFechaHabil(daysToSubstract, false);

    if (inputFromFunction < minimumDate) {
      return false;
    } else {
      return true;
    }
  }

  validarFechaHabil(days, flag) {
    const today = new Date();

    while (days > 0) {
      if (flag) {
        today.setDate(today.getDate() + 1);
      } else {
        today.setDate(today.getDate() - 1);
      }

      const esFestivo = this.esFestivo(today);

      if (!esFestivo) {
        days--;
      }
    }

    return today;
  }

  esFestivo(date) {
    const festivos = this.state.holiDays;
    const dateFormatted = date.toLocaleDateString("es-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    if (festivos.includes(dateFormatted)) {
      return true;
    } else {
      return false;
    }
  }

  formatoFecha(date) {
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);

    return `${year}-${month}-${day}`;
  }

  validarFechas() {
    const dateSelected = new Date(this.props.fechaInput);
    dateSelected.setDate(dateSelected.getDate() + 1);
    const noEsFechaValidaHabil = this.esFestivo(dateSelected);
    const esFechaValidaMinima = this.validarFechaAntiguedad(dateSelected);
    var fechaLimiteAprobacion = this.validarFechaHabil(
      this.state.diasHabilA,
      true
    );

    const fechaLimiteAprobacionFormated = this.formatoFecha(
      fechaLimiteAprobacion
    );

    this.props.modifyInputs(
      "solicitud",
      "fecha_limite_aprobacion",
      fechaLimiteAprobacionFormated
    );

    if (noEsFechaValidaHabil) {
      this.props.llamarMensajesAlerta(
        "La fecha seleccionada es un dia festivo o domingo"
      );
      this.props.modifyInputs("solicitud", "fecha", null);
    }

    if (!esFechaValidaMinima) {
      this.props.llamarMensajesAlerta(
        `El tiempo de antiguedad minimo es de ${this.state.diasAnti} dias habiles`
      );
      this.props.modifyInputs("solicitud", "fecha", null);
    }
  }

  componentDidMount() {
    this.props.obtenerParametro("DIAS_ANTI");
    this.props.obtenerParametro("DIAS_FESTIVOS");
    this.props.obtenerParametro("DIAS_HABILES_DIS");
  }

  componentDidUpdate() {
    if (
      this.props.diasF !== undefined &&
      this.props.diasA !== undefined &&
      this.props.diasHA !== undefined
    ) {
      this.state.holiDays = this.holidaysArray(this.props.diasF.toJS());
      this.state.diasAnti = this.props.diasA.toJS()[0].dias_anti;
      this.state.diasHabilA = this.props.diasHA.toJS()[0].dias;
    }

    if (
      this.props.fechaInput != undefined &&
      this.state.diasHabilA !== undefined
    ) {
      this.validarFechas();
    }
  }

  holidaysArray(response) {
    const holiDays = [];
    response.map((x) => holiDays.push(x.dia_festivo));
    return holiDays;
  }

  renderDetalles = (detalles) => {
    const cancelledOrBilled =
      this.props.estado == "CANCELADA" || this.props.estado == "FACTURADA";

    const output = [];
    const columns = [
      {
        ID: 0,
        CAPTION: "",
        VALUE: "selected",
        TYPE: "selection",
        INPUT: "checkbox",
        WIDTH: 24,
        FIXED: true,
      },
      {
        ID: 1,
        CAPTION: "Tipo de servicio",
        TYPE: "custom",
        RENDER_ROW: (reg) => {
          return (
            <span
              style={{ color: "#4f9fcf", cursor: "pointer" }}
              onClick={(e) =>
                this.props.showHideModalAdicionarDetalles(
                  true,
                  reg.get("id3n71f13r")
                )
              }
            >
              {reg.getIn("tipo_servicio".split("."))}
            </span>
          );
        },
      },
      {
        ID: 2,
        CAPTION: "Tipo de producto",
        VALUE: "tipo_producto",
        TYPE: "text",
      },
      { ID: 3, CAPTION: "Menu", VALUE: "menu", TYPE: "text", WIDTH: 300 },
      {
        ID: 4,
        CAPTION: "Valor unitario",
        VALUE: "valor_unitario",
        TYPE: "number",
      },
      { ID: 5, CAPTION: "Cantidad", VALUE: "cantidad", TYPE: "number" },
      { ID: 6, CAPTION: "Subtotal", VALUE: "subtotal", TYPE: "number" },
    ];

    if (cancelledOrBilled) {
      columns[1] = {
        ID: 1,
        CAPTION: "Tipo de servicio",
        VALUE: "tipo_servicio",
        TYPE: "text",
      };
    }

    output.push(
      <Table
        key="our[0][0]"
        reducer="solicitud"
        table="detalles"
        columns={columns}
      />
    );

    return output;
  };

  renderRecursos = (distribuciones) => {
    const cancelledOrBilled =
      this.props.estado == "CANCELADA" || this.props.estado == "FACTURADA";

    const output = [];
    const columns = [
      {
        ID: 0,
        CAPTION: "",
        VALUE: "selected",
        TYPE: "selection",
        INPUT: "checkbox",
        WIDTH: 24,
        FIXED: true,
      },
      {
        ID: 1,
        CAPTION: "Centro de costo",
        TYPE: "custom",
        RENDER_ROW: (reg) => {
          return (
            <span
              style={{ color: "#4f9fcf", cursor: "pointer" }}
              onClick={(e) =>
                this.props.showHideModalAdicionarCencos(
                  true,
                  reg.get("id3n71f13r")
                )
              }
            >
              {reg.getIn("cenco.codigo".split("."))}
            </span>
          );
        },
      },
      { ID: 2, CAPTION: "Nombre", VALUE: "cenco.nombre", TYPE: "text" },
      {
        ID: 3,
        CAPTION: "Ordenador del gasto",
        VALUE: "cenco.aprobador.name",
        TYPE: "text",
      },
      {
        ID: 4,
        CAPTION: "Porcentaje",
        TYPE: "custom",
        RENDER_ROW: (reg) => {
          let val = reg.getIn("porcentaje".split("."));
          return (
            <div style={{ textAlign: "right" }}>
              {numeral(val / 100).format("0.00%")}
            </div>
          );
        },
      },
      {
        ID: 5,
        CAPTION: "Total",
        VALUE: "total",
        TYPE: "number",
        FORMAT: "$0,0.00",
        WIDTH: 96,
      },
      {
        ID: 6,
        CAPTION: "Disponible",
        VALUE: "cenco.presupuesto.0.valor_disponible",
        TYPE: "number",
        FORMAT: "$0,0.00",
      },
    ];

    if (cancelledOrBilled) {
      columns[1] = {
        ID: 1,
        CAPTION: "Centro de costo",
        VALUE: "cenco.codigo",
        TYPE: "text",
      };
    }

    output.push(
      <Table
        key="our[1][0]"
        reducer="solicitud"
        table="distribuciones"
        columns={columns}
      />
    );

    return output;
  };

  render() {
    const { isEditable } = this.props;

    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div className="row" style={{ height: "100%" }}>
          <div className="col-md-12" style={{ height: "100%" }}>
            <div className="box-content" style={{ flex: 1 }}>
              <BoxSection title="Información básica">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="control-label">Solicitante</label>
                      <Input
                        type="text"
                        reducer="solicitud"
                        path="solicitante.name"
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="control-label">Correo</label>
                      <Input
                        type="text"
                        reducer="solicitud"
                        path="solicitante.email"
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-1">
                    <div className="form-group">
                      <label className="control-label">Extensión</label>
                      <Input
                        type="text"
                        reducer="solicitud"
                        path="solicitante.extension"
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label className="control-label">Área</label>
                      <Input
                        type="text"
                        reducer="solicitud"
                        path="solicitante.area"
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label className="control-label">Estado</label>
                      <Input
                        type="text"
                        reducer="solicitud"
                        path="estado"
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              </BoxSection>
              <div className="separator"></div>
              <BoxSection title="Información del servicio">
                <div className="row">
                  <div className="col-md-5">
                    <div className="form-group">
                      <label className="control-label">
                        Evento o actividad
                      </label>
                      <Input
                        type="text"
                        reducer="solicitud"
                        path="evento_actividad"
                        disabled={!isEditable}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label className="control-label">Cafetería</label>
                      <Input
                        type="select"
                        reducer="solicitud"
                        path="cafeteria"
                        options={this.props.cafeterias.toJS().map((x) => {
                          return {
                            value: JSON.stringify(x),
                            caption: x.nombre,
                          };
                        })}
                        disabled={!isEditable}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="control-label">Fecha y hora</label>
                      <div className="row">
                        <div
                          className="col-md-7"
                          style={{ paddingRight: "2px" }}
                        >
                          <Input
                            type="date"
                            reducer="solicitud"
                            path="fecha"
                            disabled={!isEditable}
                          />
                        </div>
                        <div
                          className="col-md-5"
                          style={{ paddingLeft: "2px" }}
                        >
                          <Input
                            type="time"
                            reducer="solicitud"
                            path="hora"
                            disabled={!isEditable}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label className="control-label">Lugar</label>
                      <Input
                        type="text"
                        reducer="solicitud"
                        path="lugar"
                        disabled={!isEditable}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="control-label">Motivo del evento</label>
                      <Input
                        type="textarea"
                        reducer="solicitud"
                        path="motivo"
                        disabled={!isEditable}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="control-label">Observaciones</label>
                      <Input
                        type="textarea"
                        reducer="solicitud"
                        path="observaciones"
                        disabled={!isEditable}
                      />
                    </div>
                  </div>
                </div>
              </BoxSection>
              <div className="separator"></div>
              <BoxSection
                title="Detalles del servicio"
                actions={[
                  <BoxButton
                    key="ba[0][0]"
                    size={14}
                    contrast
                    name="plus-circle"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.showHideModalAdicionarDetalles(true);
                    }}
                    title="Adicionar detalle"
                    disabled={!isEditable}
                  />,
                  <BoxButton
                    key="ba[0][1]"
                    size={14}
                    contrast
                    name="trash"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.showModalConfirmAction(
                        true,
                        "Está seguro que desea eliminar los registros seleccionados?",
                        () => this.props.eliminarDetalle()
                      );
                    }}
                    title="Eliminar"
                    disabled={ isEditable ? 
                      this.props.detalles &&
                      this.props.detalles
                        .valueSeq()
                        .filter((x) => x.get("selected"))
                        .count() === 0
                        : !isEditable
                    }
                    danger
                  />,
                ]}
              >
                <div style={{ height: "120px" }}>
                  {this.renderDetalles(this.props.detalles)}
                </div>
              </BoxSection>
              <div className="separator"></div>
              <BoxSection
                title="Recursos"
                actions={[
                  <BoxButton
                    key="ba[1][0]"
                    size={14}
                    contrast
                    name="plus-circle"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.showHideModalAdicionarCencos(true);
                    }}
                    title="Adicionar distribución"
                    disabled={!isEditable}
                  />,
                  <BoxButton
                    key="ba[2][1]"
                    size={14}
                    contrast
                    name="trash"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.showModalConfirmAction(
                        true,
                        "Está seguro que desea eliminar los registros seleccionados?",
                        () => this.props.eliminarRecurso()
                      );
                    }}
                    title="Eliminar"
                    disabled={ isEditable ?
                      this.props.detalles &&
                      this.props.distribuciones
                        .valueSeq()
                        .filter((x) => x.get("selected"))
                        .count() === 0
                        : !isEditable
                    }
                    danger
                  />,
                ]}
              >
                <div style={{ height: "120px" }}>
                  {this.renderRecursos(this.props.distribuciones)}
                </div>
              </BoxSection>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    cafeterias: state.solicitud.get("cafeterias"),
    detalles: state.solicitud.getIn("detalles.data".split(".")),
    diasA: state.solicitud.get("dias_anti"),
    diasF: state.solicitud.get("dias_festivos"),
    diasHA: state.solicitud.get("dias_habiles_dis"),
    fechaInput: state.solicitud.getIn("fecha".split(".")),
    distribuciones: state.solicitud.getIn("distribuciones.data".split(".")),
    estado: state.solicitud.get("estado"),
  };
}

const mapDispatchToProps = {
  obtenerParametro,
  reiniciarEstado,
  showHideModalAdicionarDetalles,
  showHideModalAdicionarCencos,
  eliminarDetalle,
  eliminarRecurso,
  showModalConfirmAction,
  llamarMensajesAlerta,
  modifyInputs: inputActions.modifyInputs,
};

export default connect(mapStateToProps, mapDispatchToProps)(General);
